<template>
<div>
  <div class="jumbotron">
    <div class="row">
      <h1 class="header-text">Start a Message</h1>
    </div>
    <div class="row">
      <p>Create an automatic greeting for customers that message you about this coupon.<span v-if="!message" class="red-text">*</span></p>
    </div>
    <div class="row">
      <div class="col">
        <textarea v-bind:class="{'is-invalid': messageInvalid}" class="cover-open-space form-control" rows="8" v-model="message" placeholder="Hi! Thanks for selecting our coupon, how can we help you today?"></textarea>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <router-link tag="button"
                     to="/profile/business/advertising/coupons/details"
                     class="btn btn-secondary cover-open-space">Back</router-link>
      </div>
      <div class="col-6">
        <button v-on:click="validate" class="btn btn-primary">Next</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      // Form validation variables
      messageInvalid: false,
      formInvalid: false
    }
  },
  methods: {
    ...mapMutations('products', [
      'updateCouponDefaultResponse'
    ]),
    validate () {
      this.formInvalid = false
      if (!this.message) {
        this.messageInvalid = true
        this.formInvalid = true
      } else {
        this.messageInvalid = false
      }

      if (this.formInvalid) return

      this.$router.push('/profile/business/advertising/coupons/legal')
    }
  },
  computed: {
    ...mapGetters('products', [
      'getCouponCategory',
      'getCouponDefaultResponse'
    ]),
    category () {
      return this.getCouponCategory
    },
    message: {
      get () {
        return this.getCouponDefaultResponse
      },
      set (value) {
        this.updateCouponDefaultResponse(value)
      }
    }
  }
}
</script>

<style scoped>
.cover-open-space {
  width: 100% !important;
}

.header-text {
  font-size: 2rem;
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/coupons/subnavItems/Messages.vue